import { stringify } from 'querystring';
import { parseSearch } from '@peloton/redux';
import { isDefined } from '@peloton/types';
import type { SupportedQueryParams } from './types';
import { ShortcutKeysArray, StateKeyForShortcut } from './types';

/**
 * Merges state into current query string, taking care to only touch supported state keys.
 * @param state supported State
 * @returns query string for URL
 */
export const mergeQueryParams = (state: SupportedQueryParams): string => {
  /**
   * Use `parseSearch` as using `URLSearchParam` for encoding can lead to unexpected results.
   * See https://stackoverflow.com/questions/59889140/different-output-from-encodeuricomponent-vs-urlsearchparams.
   */
  const searchParams = parseSearch(location);

  ShortcutKeysArray.forEach(shortcut => {
    const queryParam = StateKeyForShortcut[shortcut];
    const stateValue = state[queryParam];
    if (isDefined(stateValue)) {
      if (typeof stateValue !== 'string') {
        searchParams[shortcut] = stateValue.toString();
      } else if (stateValue.length > 0) {
        searchParams[shortcut] = stateValue;
      } else {
        delete searchParams[shortcut];
      }
    } else {
      delete searchParams[shortcut];
    }
  });

  return stringify(searchParams);
};
